import React from "react";
import { useParams } from "react-router-dom";
import { Section } from "@sunwing/components";
import { withRouter } from "utilities/withRouter";
import AppFooter from "@APP_FOOTER";
import AppHeader from "@APP_HEADER";
import "./display.css";

const Display = (props) => {

    //console.log(props);

    const params = useParams() || {};

    let language = params && params["languageCode"]?.toLowerCase();
    const url = params && params["url"];
    
    if(!url) return props.navigate("/home");
    if(!language) return null;

    const decodedUrl = atob(url);

    // console.log("Encoded:", url);

    return (
        <div className="base-container"> 
            <AppHeader language={language} />
            <div className="main">
                <div className="row margin-bottom-4x review-group-responsive">
                    <div className="row">
                        <Section className="print-hide">
                            <div className="page-main-container margin-bottom-1x">
                                <iframe
                                    src={ decodedUrl + "?view=icon&sortDirection=ASC" }
                                    width="100%"
                                    height="800"
                                    className="box-pdf"
                                    frameborder="0"
                                    allowfullscreen
                                    webkitallowfullscreen
                                    msallowfullscreen
                                ></iframe>
                            </div>
                        </Section>
                    </div>
                </div>
            </div>
            <AppFooter language={language} />
        </div>
    );
    
};

export default withRouter(Display);